import React, { useEffect, useState } from 'react'
import icon_1 from "assets/images/specialties/1.png";
import icon_2 from "assets/images/specialties/2.png";
import icon_3 from "assets/images/specialties/3.png";
import icon_4 from "assets/images/specialties/4.png";
import icon_5 from "assets/images/specialties/5.png";
import icon_6 from "assets/images/specialties/6.png";
import icon_7 from "assets/images/specialties/7.png";
import icon_8 from "assets/images/specialties/8.png";
import icon_9 from "assets/images/specialties/9.png";
import icon_10 from "assets/images/specialties/10.png";
import icon_11 from "assets/images/specialties/11.png";
import icon_12 from "assets/images/specialties/12.png";
import { PractitionerService } from 'utils/PractitionerService';

export default function TopSearchSpecialties({ handleCardClick }) {
    const [dentistsCountOnPlatform, setDentistsCountOnPlatform] = useState(0);
    const [primaryCareCountOnPlatform, setPrimaryCareCountOnPlatform] = useState(0);
    const [cardiologyCountOnPlatform, setCardiologyCountOnPlatform] = useState(0);
    const [gastroenterologyCountOnPlatform, setGastroenterologyCountOnPlatform] = useState(0);
    const [pediatricianCountOnPlatform, setPediatricianCountOnPlatform] = useState(0);
    const [psychiatryCountOnPlatform, setPsychiatryCountOnPlatform] = useState(0);
    const [dermatologyCountOnPlatform, setDermatologyCountOnPlatform] = useState(0);
    const [diabetologyCountOnPlatform, setDiabetologyCountOnPlatform] = useState(0);
    const [physiotherapyCountOnPlatform, setPhysiotherapyCountOnPlatform] = useState(0);
    const [orthopaedicsCountOnPlatform, setOrthopaedicsCountOnPlatform] = useState(0);
    const [gynecologyCountOnPlatform, setGynecologyCountOnPlatform] = useState(0);
    const [oncologyCountOnPlatform, setOncologyCountOnPlatform] = useState(0);


    const getDentistsCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Dentist")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setDentistsCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getPrimaryCareCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Family Medicine")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setPrimaryCareCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getCardiologyCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Cardiology")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setCardiologyCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getGastroenterologyCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Gastroenterology")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setGastroenterologyCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getPediatricianCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Pediatrics")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setPediatricianCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getPsychiatryCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Psychiatry")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setPsychiatryCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getDermatologyCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Dermatology")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setDermatologyCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getDiabetologyCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Diabetology")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setDiabetologyCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getPhysiotherapyCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Physiotherapy")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setPhysiotherapyCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getOrthopaedicsCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Orthopaedics")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setOrthopaedicsCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getGynecologyCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Obstetrics & Gynaecology")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setGynecologyCountOnPlatform(data?.totalItems);
                }
            })
    }

    const getOncologyCount = () => {
        PractitionerService.getAllProfiles(`ps == "${encodeURIComponent("Oncology")}"`, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    setOncologyCountOnPlatform(data?.totalItems);
                }
            })
    }


    useEffect(() => {
        getDentistsCount();
        getPrimaryCareCount();
        getCardiologyCount();
        getGastroenterologyCount();
        getPediatricianCount();
        getPsychiatryCount();
        getDermatologyCount();
        getDiabetologyCount();
        getPhysiotherapyCount();
        getOrthopaedicsCount();
        getGynecologyCount();
        getOncologyCount();
    }, [])

    return (
        <div className='top-searched-specialties'>
            <h2 className='nex-text-xl nex-color-dark-blue'>Top-searched specialties</h2>
            <div className="top-searched-spec-items">
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Dentist")}>
                    <div className="graphic">
                        <img src={icon_1} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Dentistry</h3>
                        <p>{dentistsCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Family Medicine")}>
                    <div className="graphic">
                        <img src={icon_2} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Primary care</h3>
                        <p>{primaryCareCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Cardiology")}>
                    <div className="graphic">
                        <img src={icon_3} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Cardiology</h3>
                        <p>{cardiologyCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Gastroenterology")}>
                    <div className="graphic">
                        <img src={icon_4} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Gastroenterology</h3>
                        <p>{gastroenterologyCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Pediatrics")}>
                    <div className="graphic">
                        <img src={icon_5} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Pediatrician</h3>
                        <p>{pediatricianCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Psychiatry")}>
                    <div className="graphic">
                        <img src={icon_6} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Psychiatry</h3>
                        <p>{psychiatryCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Dermatology")}>
                    <div className="graphic">
                        <img src={icon_7} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Dermatology</h3>
                        <p>{dermatologyCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Diabetology")}>
                    <div className="graphic">
                        <img src={icon_8} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Diabetology</h3>
                        <p>{diabetologyCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Physiotherapy")}>
                    <div className="graphic">
                        <img src={icon_9} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Physiotherapy</h3>
                        <p>{physiotherapyCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Orthopaedics")}>
                    <div className="graphic">
                        <img src={icon_10} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Orthopaedics</h3>
                        <p>{orthopaedicsCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Gynaecology")}>
                    <div className="graphic">
                        <img src={icon_11} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Gynecology</h3>
                        <p>{gynecologyCountOnPlatform} specialists</p>
                    </div>
                </div>
                <div className="top-searched-spec-item" onClick={() => handleCardClick("Oncology")}>
                    <div className="graphic">
                        <img src={icon_12} alt="" />
                    </div>
                    <div className="info">
                        <h3 className='title'>Oncology</h3>
                        <p>{oncologyCountOnPlatform} specialists</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
